import { render, staticRenderFns } from "./LocationPin.vue?vue&type=template&id=0f0a3257"
import script from "./LocationPin.vue?vue&type=script&lang=ts"
export * from "./LocationPin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports